
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 40 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M36.79 26.255c-2.449 0-4.853-.383-7.132-1.136-1.136-.387-2.43-.086-3.17.669l-4.498 3.395c-5.216-2.784-8.429-5.996-11.175-11.173l3.295-4.38a3.233 3.233 0 00.796-3.276 22.744 22.744 0 01-1.14-7.144c0-1.77-1.44-3.21-3.21-3.21H3.21C1.44 0 0 1.44 0 3.21 0 23.496 16.504 40 36.79 40c1.77 0 3.21-1.44 3.21-3.21v-7.325c0-1.77-1.44-3.21-3.21-3.21zm.988 10.535a.988.988 0 01-.988.988C17.73 37.778 2.222 22.27 2.222 3.21c0-.545.443-.988.988-.988h7.346c.544 0 .987.443.987.988 0 2.687.422 5.325 1.248 7.824.115.37.021.751-.352 1.14l-3.82 5.058c-.255.34-.295.794-.103 1.173 3.117 6.127 6.905 9.915 13.076 13.077.375.197.835.155 1.176-.102l5.175-3.92a.98.98 0 011.007-.235 24.95 24.95 0 007.84 1.253c.545 0 .988.442.988.987v7.325z","fill":"currentColor"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M31.748 14.644c0 .749-.607 1.356-1.356 1.356h-5.036A1.356 1.356 0 0124 14.644V9.608a1.356 1.356 0 012.712 0v1.762l8.306-8.306a1.356 1.356 0 011.918 1.917l-8.306 8.307h1.762c.75 0 1.356.607 1.356 1.356z","fill":"currentColor"}})])
          )
        }
      }
    